import {
  type DynamicTableExcelOptions,
  downloadDynamicTablesAsExcel,
} from '../../utils/dynamic-table-excel';
import { importDynamicTableWorkbooks } from '../../utils/dynamic-table-excel-batch';
import ExcelImportToolbar from './ExcelImportToolbar';

type Props = {
  title: string;
  tables: DynamicTableExcelOptions[];
  disabled?: boolean;
  confirmImport?: boolean;
  onImport: (values: Record<string, string>[]) => void | Promise<void>;
};

export default function DynamicTablesExcelToolbar({
  title,
  tables,
  disabled = false,
  confirmImport = true,
  onImport,
}: Props) {
  if (tables.length === 0) return null;

  return (
    <ExcelImportToolbar
      title={title}
      disabled={disabled}
      confirmImport={confirmImport}
      onDownload={() => downloadDynamicTablesAsExcel({ title, tables })}
      readFiles={(files) => importDynamicTableWorkbooks(files, { title, tables })}
      onImport={onImport}
    />
  );
}
